import React, { useState } from 'react';
import {
  SEMANTIC_ROLE_OPTIONS,
  labelForSemanticRole,
  humanReadableFormula,
  describeAst,
  buildDependencyMaps,
} from '../../adapters';

const AdvancedTab = ({
  field,
  fields,
  readOnly,
  isPrivileged,
  onChange,
  onGoToField,
  onOpenRelationshipMap,
}) => {
  const [showRaw, setShowRaw] = useState(false);
  const [showGenerated, setShowGenerated] = useState(false);
  const { dependsOn, usedBy } = buildDependencyMaps(fields);
  const deps = dependsOn[field.fieldCode] || [];
  const used = usedBy[field.fieldCode] || [];
  const roleOwner = (fields || []).find(
    (f) => f.fieldCode !== field.fieldCode
      && field.semanticRole
      && f.semanticRole === field.semanticRole
      && String(f.status || 'ACTIVE') === 'ACTIVE',
  );
  const labelOf = (code) => (fields || []).find((f) => f.fieldCode === code)?.fieldLabel || code;

  return (
    <div className="ra-tpl-tab-body">
      <div className="form-group">
        <label>Internal Field Code</label>
        <input value={field.fieldCode || ''} disabled />
      </div>

      <div className="form-group">
        <label>System Meaning</label>
        <select
          disabled={readOnly}
          value={field.semanticRole || ''}
          onChange={(e) => onChange({ semanticRole: e.target.value || null })}
        >
          <option value="">— None —</option>
          {SEMANTIC_ROLE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <p className="ra-tpl-help">This tells the RA Register which custom field represents core totals like Net Payable. Most recoveries do not need a system meaning.</p>
        {roleOwner && (
          <div className="ra-tpl-warn-box">
            {labelForSemanticRole(field.semanticRole)} is already assigned to &quot;{roleOwner.fieldLabel || roleOwner.fieldCode}&quot;.
            <button type="button" className="btn-secondary btn-sm" onClick={() => onGoToField(roleOwner.fieldCode)}>Go to field</button>
          </div>
        )}
      </div>

      <div className="form-group">
        <label>Formula Status</label>
        <div className="ra-tpl-status-line">
          {field.formulaJson || field.fieldType === 'INPUT' || field.fieldType === 'PREVIOUS_RA' ? 'Valid ✓' : 'Needs calculation rule'}
        </div>
      </div>

      <div className="form-group">
        <label>Depends On</label>
        <div className="ra-tpl-chip-row">
          {deps.length === 0 ? <span className="ra-tpl-muted">None</span> : deps.map((d) => (
            <button key={d} type="button" className="ra-tpl-chip ra-tpl-chip--btn" onClick={() => onGoToField(d)}>{labelOf(d)}</button>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>Used By</label>
        <div className="ra-tpl-chip-row">
          {used.length === 0 ? <span className="ra-tpl-muted">None</span> : used.map((d) => (
            <button key={d} type="button" className="ra-tpl-chip ra-tpl-chip--btn" onClick={() => onGoToField(d)}>{labelOf(d)}</button>
          ))}
        </div>
      </div>

      <div className="ra-tpl-adv-actions">
        <button type="button" className="btn-secondary btn-sm" onClick={() => setShowGenerated((v) => !v)}>
          {showGenerated ? 'Hide' : 'View'} Generated Formula
        </button>
        <button type="button" className="btn-secondary btn-sm" onClick={onOpenRelationshipMap}>View Relationship Map</button>
        {isPrivileged && (
          <button type="button" className="btn-secondary btn-sm" onClick={() => setShowRaw((v) => !v)}>
            {showRaw ? 'Hide' : 'View'} Raw JSON
          </button>
        )}
      </div>

      {showGenerated && (
        <pre className="ra-tpl-code-block">{humanReadableFormula(field, fields)}\n\n{describeAst(field.formulaJson, Object.fromEntries((fields || []).map((f) => [f.fieldCode, f])))}</pre>
      )}
      {showRaw && isPrivileged && (
        <pre className="ra-tpl-code-block">{JSON.stringify(field.formulaJson, null, 2) || 'null'}</pre>
      )}
    </div>
  );
};

export default AdvancedTab;
